module.exports = __webpack_public_path__ + "static/logoLunares-66c9ae226480ffcdb294189a1aa17331.png";